export var ShoppingListStatusApi;
(function (ShoppingListStatusApi) {
    ShoppingListStatusApi["pending"] = "pending";
    ShoppingListStatusApi["sent"] = "sent";
    ShoppingListStatusApi["declined"] = "declined";
    ShoppingListStatusApi["purchased"] = "purchased";
    ShoppingListStatusApi["checkout"] = "checkout";
    ShoppingListStatusApi["awaitingPaymentValidation"] = "awaitingPaymentValidation";
})(ShoppingListStatusApi || (ShoppingListStatusApi = {}));
//# sourceMappingURL=shopping-list-status.js.map